<template>
  <div class="coupon-contain">
    <van-cell title="优惠劵" :value="couponText" size="large" @click="showCoupon = true" />
    <van-popup v-model="showCoupon" position="bottom" :style="{ height: '60vh' }" closeable>
      <div class="coupon">
        <div class="coupon-title">优惠券</div>
        <div class="coupon-list">
          <van-radio-group :value="value">
            <couponItem v-for="item in info" :key="item.id" :value="item">
              <template slot="right">
                <van-radio :name="item.id" @click="selected(item)"></van-radio>
              </template>
            </couponItem>
            </van-radio-group>
        </div>
        <van-button @click="comfirm" color="#5a9dff" class="pay-action" round>不使用优惠</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Cell, Radio, RadioGroup, Button } from 'vant'
import couponItem from './couponItem'
export default {
  name: 'Coupon',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    info: {
      type: Array
    },
    value: {
      type: [Number, String],
      default: ''
    }
  },
  components: {
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    couponItem
  },
  data () {
    return {
      showCoupon: false,
      selectedId: '',
    }
  },
  computed: {
    couponText () {
      if (this.value) {
        return this.info.find(item => item.id === this.value).name
      } else {
        return `当前可使用优惠劵` + this.info?.length + `张`
      }
    }
  },
  methods: {
    selected (item) {
      console.log(item);
      
      // this.selectedId = item.id === this.selectedId ? '' : item.id
      this.$emit('change', item.id)
      this.showCoupon = false
    },
    comfirm () {
      this.$emit('change', '')
      this.showCoupon = false
      // this.$emit('change', this.selectedId)
      // this.showCoupon = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .coupon {
    font-size: 0.28rem;
    .coupon-title{
      text-align: center;
      font-size: 0.38rem;
      margin: 0.3rem 0;
    }
    .coupon-list{
      padding: 0.2rem;
      overflow-y: scroll;
      height: 40vh;
      margin: 0.1rem 0;
      background: #efefef;
    }
    .coupon-item{
      margin: 0.2rem 0;
      padding: 0.1rem;
      background: #fff;
      border-radius: 0.1rem;
      @include flex();
      .coupon-item-left{
        color: red;
        @include flex(flex-start);
        img{
          margin-right: 0.1rem;
          width: 1.2rem;
          height: 1.2rem;
        }
      }
    }
  }
  .pay-action{
    margin: 0 auto;
    text-align: center;
    width: 90%;
    display: block;
  }
  .coupon-contain{
    padding: 0.1rem;
    margin: 0.1rem;
  }
</style>